import { FIELD_TYPE } from "types/enums";
import { DataFormField } from "types/models/input-field-type";
const { INPUT, SELECT, DATE, COLOR } = FIELD_TYPE;
const dataFields: DataFormField[] = [
  {
    type: INPUT,
    label: "Mã trình tự",
    name: "maTrinhTu",
    disable: true,
  },
  {
    type: INPUT,
    label: "Tên mẫu",
    name: "tenMau",
    rules: [{ required: true, message: "Chưa nhập tên mẫu" }],
  },
  {
    type: SELECT,
    label: "Trạng thái",
    name: "idTrangThaiDanhMucPhauThuat",
    options: [
      { value: 0, label: "Đang sử dụng" },
      { value: 1, label: "Dừng sử dụng" },
    ],
    rules: [{ required: true, message: "Chưa nhập mã máy CĐHA" }],
  },
];
export { dataFields };
